export const LOCALE = 'LOCALE';
export const ACCESS_TOKEN = 'token';
export const REFRESH_TOKEN = 'refreshToken';
export const CURRENT_USER = 'currentUser';
export const REDIRECT_URL_KEY = 'redirectUrl';
export const INIT_VISIT = 'initVisit';

export const GOOGLE_AUTH_REDIRECT_URI =
	!process.env.NODE_ENV || process.env.NODE_ENV === 'development'
		? 'http://localhost:3000'
		: 'https://test.italent.kz';

export const MAIL_RU_AUTH_REDIRECT_URI =
	!process.env.NODE_ENV || process.env.NODE_ENV === 'development'
		? 'http://localhost:3000/login'
		: 'https://test.italent.kz/login';

export const APPLE_AUTH_REDIRECT_URI =
	!process.env.NODE_ENV || process.env.NODE_ENV === 'development'
		? 'http://localhost:3000/login'
		: 'https://api.italent.kz/api/test-service/auth/apple/redirect';

export const TEST_CURRENT_QUESTION = 'currentQuestion';
export const TEST_ANSWER = 'answers';
export const TEST_IS_COMPLETED = 'isCompleted';
export const PAYMENT_PAGE_TYPE = 'pageType';

export const DEFAULT_COOKIE_OPTIONS = {
	days: 30,
	path: '/',
	secure: true,
	sameSite: 'Lax' as const,
	domain: '.italent.kz'
};
